import type { PostInputMetaData } from '../../graphqlTypes'
import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'

import type { MapperContext } from '../../types'
import { clearable } from '../shared/clearable'
import type { ServiceMapperEntry } from '../types'

// Start Page's only metadata is an optional link (`channelData.startPage.link`,
// distinct from the `draft.link` attachment asset). Tri-stated via `clearable`:
// omitted on create, `null` on edit to clear the stored link.
//
// `ctx.channelVariant` (when present) supplies the same field.
export function mapStartPage(
  draft: Draft,
  ctx: MapperContext,
): PostInputMetaData {
  const variant = ctx.channelVariant
  const link = variant
    ? variant.channelData?.startPage?.link
    : draft.channelData?.startPage?.link

  return { startPage: { link: clearable(link, ctx) } }
}

export const startPage: ServiceMapperEntry = {
  mapper: mapStartPage,
}
